document.addEventListener("BSS:changeqty", e => {
  const styleId = 'custom-cart-popup-style';
    if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            #CartPopup-Checkout {
                pointer-events: none !important;
                opacity: 0.6 !important;
            }
        `;
        document.head.appendChild(style);
        setTimeout(() => {
            const existingStyle = document.getElementById(styleId);
            if (existingStyle) {
                existingStyle.remove();
            }
        }, 2000);
    }
})